module.exports = __webpack_public_path__ + "static/media/LV2@4x.1e63798f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/MapElements/LV/LV2@4x.png
// module id = 677
// module chunks = 0